// 📄 components/integracion/TransportConfirmationPanel.tsx
// Reemplaza el botón manual de "Guardar Ajustes" en QAS/PRD: en esos
// ambientes los parámetros/OT/Personalización Z se heredan de DEV en modo
// lectura, y lo único que se registra es si la OT ya fue transportada y
// cuándo — ver TransportConfirmation.
import { CalendarCheck, Save } from 'lucide-react';
import { TransportConfirmation } from '../../types/transportConfirmation.ts';

interface Props {
  env: 'QAS' | 'PRD';
  value: TransportConfirmation;
  onChange: (value: TransportConfirmation) => void;
  onConfirm: () => void;
  saving: boolean;
}

const ACCENT: Record<'QAS' | 'PRD', { ring: string; dot: string; button: string }> = {
  QAS: { ring: 'border-orange-500/30', dot: 'peer-checked:bg-orange-500', button: 'bg-orange-500 hover:bg-orange-600' },
  PRD: { ring: 'border-red-500/30', dot: 'peer-checked:bg-red-500', button: 'bg-red-500 hover:bg-red-600' }
};

export default function TransportConfirmationPanel({ env, value, onChange, onConfirm, saving }: Props) {
  const accent = ACCENT[env];

  return (
    <div className={`border-t border-white/10 pt-4 space-y-4`}>
      <div className={`bg-white/5 border ${accent.ring} rounded-xl p-4 space-y-4`}>
        <div className="flex items-center gap-2 text-xs font-semibold text-gray-300 uppercase tracking-wider">
          <CalendarCheck className="w-4 h-4" />
          Confirmación de Transporte (Cutover)
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={value.transported || false}
                onChange={(e) => onChange({ ...value, transported: e.target.checked })}
                className="sr-only peer"
              />
              <div className={`w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full ${accent.dot} after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all`}></div>
            </label>
            <span className="text-xs font-medium">¿OT transportada a {env}?</span>
          </div>

          <div className="flex-1 max-w-xs">
            <label className="block text-[10px] font-medium text-gray-400 mb-1">Fecha de pase a {env}</label>
            <input
              type="date"
              value={value.transportDate || ''}
              onChange={(e) => onChange({ ...value, transportDate: e.target.value })}
              className="w-full bg-zinc-800 border border-white/10 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-white/30"
            />
          </div>
        </div>

        <div className="flex justify-end pt-1">
          <button
            type="button"
            onClick={onConfirm}
            disabled={saving}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all shadow-lg text-slate-950 ${accent.button} disabled:bg-gray-600`}
          >
            <Save className="w-4 h-4" />
            {saving ? 'Guardando...' : `Confirmar Pase a ${env}`}
          </button>
        </div>
      </div>
    </div>
  );
}
